import ReactDOM from 'react-dom/client'
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom'
import reportWebVitals from './reportWebVitals'

import './index.css'
import './global.css'
import { PrescriptionPage } from './pages/prescription/prescription.page'
import { SuccessPage } from './pages/success/success.page'
import { ErrorPage } from '@/pages/error/error.page'
import { initAnalytics, trackEvent, trackPageView } from '@/services/analytics.service'

initAnalytics()

const router = createBrowserRouter([
  {
    path: '/:id',
    element: <PrescriptionPage />
  },
  // Rutas con receta: los datos se piden al backend por el id, sin query string.
  {
    path: '/:id/success',
    element: <SuccessPage />
  },
  {
    path: '/:id/error',
    element: <ErrorPage />
  },
  // Genérica + retrocompatibilidad: /success sigue leyendo el ticket del query
  // string para los enlaces ya repartidos.
  {
    path: '/success',
    element: <SuccessPage />
  },
  {
    path: '/error',
    element: <ErrorPage />
  },
  {
    path: '*',
    element: <ErrorPage />
  }
], { basename: process.env.PUBLIC_URL })

// GA4 va configurado con send_page_view: false, así que la page_view la manda
// el router en cada navegación. Se engancha al router (no a un componente) para
// no tener que tocar el árbol de rutas.
let lastTrackedPath: string | null = null

function trackLocation (location: { pathname: string, search: string }): void {
  const path = `${location.pathname}${location.search}`

  if (path === lastTrackedPath) {
    return
  }

  lastTrackedPath = path
  trackPageView(location.pathname)
}

trackLocation(router.state.location)
router.subscribe((state) => {
  if (state.navigation.state === 'idle') {
    trackLocation(state.location)
  }
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <RouterProvider
    router={router}
  />
)

// Web Vitals hacia GA4: LCP, CLS, INP/FID, FCP y TTFB por dispositivo/navegador.
reportWebVitals(({ name, value, id }) => {
  trackEvent('web_vitals', {
    metric_name: name,
    // CLS es un ratio; el resto son milisegundos. GA4 solo acepta números.
    metric_value: name === 'CLS' ? Math.round(value * 1000) : Math.round(value),
    metric_id: id
  })
})
